import { useEffect, useState } from "react";
import { LANDING } from "@/constants/testIds";

function diffParts(deadlineISO) {
  if (!deadlineISO) return { d: 0, h: 0, m: 0, s: 0 };
  const target = new Date(deadlineISO).getTime();
  const now = Date.now();
  let diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400000); diff -= d * 86400000;
  const h = Math.floor(diff / 3600000); diff -= h * 3600000;
  const m = Math.floor(diff / 60000); diff -= m * 60000;
  const s = Math.floor(diff / 1000);
  return { d, h, m, s };
}

export const CountdownTimer = ({ deadline, label = "Boarding Closes In" }) => {
  const [t, setT] = useState(diffParts(deadline));
  useEffect(() => {
    setT(diffParts(deadline));
    const i = setInterval(() => setT(diffParts(deadline)), 1000);
    return () => clearInterval(i);
  }, [deadline]);

  const Box = ({ value, unit, testId }) => (
    <div className="glass px-5 py-4 md:px-7 md:py-5 text-center" data-testid={testId}>
      <div className="text-4xl md:text-5xl font-black text-white tracking-tighter tabular-nums">
        {String(value).padStart(2, "0")}
      </div>
      <div className="label-gold mt-1 text-[0.6rem] md:text-[0.65rem]">{unit}</div>
    </div>
  );

  return (
    <div>
      <p className="label-gold text-center mb-4">{label}</p>
      <div className="flex items-center justify-center gap-2 md:gap-4">
        <Box value={t.d} unit="Days" testId={LANDING.countdownDays} />
        <span className="text-[#C9A227] text-3xl font-light">:</span>
        <Box value={t.h} unit="Hours" testId={LANDING.countdownHours} />
        <span className="text-[#C9A227] text-3xl font-light">:</span>
        <Box value={t.m} unit="Minutes" testId={LANDING.countdownMinutes} />
        <span className="text-[#C9A227] text-3xl font-light">:</span>
        <Box value={t.s} unit="Seconds" testId={LANDING.countdownSeconds} />
      </div>
    </div>
  );
};
